import { CALL_FOLLOW_UP_TASK_TYPE } from '@vagusx/shared';

/**
 * How the task page shows work a call left for a person
 * (docs/call-follow-ups.md). Kept apart from the components so the rules are
 * tested on their own.
 */

/** A task a call follow-up filed: its description is the work itself, and is shown. */
export function isCallFollowUp(task: { structuredData: Record<string, unknown> | null }): boolean {
  return task.structuredData?.type === CALL_FOLLOW_UP_TASK_TYPE;
}

/** History actions whose comment IS the note a call or a campaign left. */
const NOTE_ACTIONS = new Set(['call_follow_up', 'outreach_needs_person']);

/**
 * The note to show under a history row's line, or null. Only for a note a
 * call or a campaign left, and only when the row has its own line: otherwise
 * the comment is already the row's summary.
 */
export function historyNote(payload: {
  action: string;
  description?: string | null;
  comment?: string | null;
}): string | null {
  return NOTE_ACTIONS.has(payload.action) && payload.description && payload.comment
    ? payload.comment
    : null;
}
